export default __webpack_public_path__ + "static/media/5.9505329b.jpg";